import { render, staticRenderFns } from "./addOpp.vue?vue&type=template&id=6aa2525a"
import script from "./addOpp.vue?vue&type=script&lang=js"
export * from "./addOpp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports